import { createReducer } from '@reduxjs/toolkit';
import { fetchClaimManualPaymentsThunk } from './manual-payments.thunk';
import { ManualPaymentsByClaimState, ManualPaymentsState } from './manual-payments.types';

const emptyClaimState: ManualPaymentsByClaimState = {
  payments: [],
  manualPaymentsTotal: 0,
  isLoading: false,
  hasFetched: false,
};

const initialState: ManualPaymentsState = {
  byClaimId: {},
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(fetchClaimManualPaymentsThunk.pending, (state, action) => {
      const claimId = action.meta.arg.claimId;
      const currentState = state.byClaimId[claimId] || emptyClaimState;
      state.byClaimId[claimId] = {
        ...currentState,
        isLoading: true,
        error: undefined,
      };
    })
    .addCase(fetchClaimManualPaymentsThunk.fulfilled, (state, action) => {
      const claimId = action.meta.arg.claimId;
      state.byClaimId[claimId] = {
        payments: action.payload.manualPayments,
        manualPaymentsTotal: action.payload.manualPaymentsTotal,
        isLoading: false,
        hasFetched: true,
        error: undefined,
      };
    })
    .addCase(fetchClaimManualPaymentsThunk.rejected, (state, action) => {
      const claimId = action.meta.arg.claimId;
      const currentState = state.byClaimId[claimId] || emptyClaimState;
      state.byClaimId[claimId] = {
        ...currentState,
        isLoading: false,
        hasFetched: true,
        error: action.payload || action.error.message || 'Something went wrong.',
      };
    });
});
